import Keycloak from "keycloak-js";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import FullPageLoading from "../../components/FullPageLoading";
import {
  getFundingImageState,
  getUserWorkSpaceList,
  getWorkSpaceOptionTypes,
  getWorkSpaceType,
} from "../../redux/actions/commonApiActions";
import {
  keycloakLoginSuccess,
  setUserDetails,
  urlUpdateLoginDetails,
} from "../../redux/actions/loginDetailsActions";
import { getAllNotSawAskHelpListCount } from "../../redux/actions/myRequestActions";
import ErrorUser from "./ErrorUser";
class KeyCloakLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: this.props.keycloakAuthenticated,
      userDetailStatus: false,
      urlWorkspacePresent: false,
      urlPath: "default",
      workSpaceNamePresent: false,
    };
  }
  componentDidUpdate(prevProps) {
    let sectionData = sessionStorage.getItem("WORKSPACE");
    console.log("sectionData In", sectionData);
    if (
      this.props.loginDetails &&
      this.props.userDetails !== null &&
      this.props.authUser !== undefined &&
      // this.props.defaultWorkSpace &&
      this.props.authUser !== prevProps.authUser
    ) {
      console.log("UPDATE USER_DATA", this.props.defaultWorkSpace);
      this.props.getAllNotSawAskHelpListCount();
      if (this.props.defaultWorkSpace !== "default") {
        this.props.getWorkSpaceOptionTypes();
      }
    }


  }
  componentDidMount() {
    if (
      this.props.keycloakAuthenticated == true &&
      this.props.userDetails != null
    ) {
      if (sessionStorage.getItem("CHALLENGE_REDIRECT_PATH")) {
        this.props.history.push(
          sessionStorage.getItem("CHALLENGE_REDIRECT_PATH")
        );
      } else {
        this.props.history.push(`/${this.props.workspaceType}/home`);
      }
    } else {
      const key = Keycloak("/keycloak.json");

      key
        .init({
          onLoad: "login-required",
        })
        .then(async (authenticated) => {
          if (!!key.token) {
            console.log(key.token);
            let userInfo = await key.loadUserInfo();

            //storing token to the sessionStorage to adapt the olderFlow
            sessionStorage.setItem("TOKEN", key.token);

            this.props.keycloakLoginSuccess(key);

            // this.props.getFundingImageState(true);
            const firebase_token = sessionStorage.getItem("Firebase_Token");

            // store the info and send api
            this.props.setUserDetails(userInfo, firebase_token);
            if (sessionStorage.getItem("WORKSPACE") !== "") {
              console.log(
                "user login via url",
                sessionStorage.getItem("WORKSPACE")
              );
              this.setState({
                urlWorkspacePresent: true,
                workSpaceNamePresent: true,
              });
            } else if (sessionStorage.getItem("SHARE_POST")) {
              console.log(
                "user login via post share ulr",
                sessionStorage.getItem("WORKSPACE")
              );
              this.setState({
                urlWorkspacePresent: true,
                workSpaceNamePresent: true,
              });
            }
            // this.Mixpanelcall(userInfo);
          }
        });
    }
  }

  checkUserPresentOrNot = async (url) => {
    const path = url.split("/").slice(1, 2);
    console.log("share url path", path);
    if (path && path[0]) {
      let workSpace =
        this.props.loginDetails?.userWorkSpaceList &&
        this.props.loginDetails.userWorkSpaceList.find(
          (data) => data.slug == path[0]
        );
      console.log("User Login Via Share Url", workSpace);
      if (workSpace) {
        this.props.urlUpdateLoginDetails(workSpace);
        let workSpaceName = workSpace?.slug ? workSpace.slug : "default";
        this.setState({
          urlPath: workSpaceName,
        });
        sessionStorage.setItem("WORKSPACE", workSpaceName);
        console.log("set-user-workspace-3", workSpaceName);

        this.props.getAllNotSawAskHelpListCount();
        if (workSpaceName !== "default") {
          this.props.getWorkSpaceOptionTypes();
        }
      } else {
        sessionStorage.setItem("SHARE_POST", "");
        toast.error("Your not authorized in this workspace ,Please check Url");
        console.log("set-user-workspace-4", "default");

        sessionStorage.setItem("WORKSPACE", "default");
        this.props.getAllNotSawAskHelpListCount();
      }
    } else {
      sessionStorage.setItem("SHARE_POST", "");
      toast.error("Something went wrong,Please check Url");
      console.log("set-user-workspace-5", "default");

      sessionStorage.setItem("WORKSPACE", "default");
      this.props.getAllNotSawAskHelpListCount();
    }
    this.setState({
      urlWorkspacePresent: false,
    });
  };
  setUserUrlWorkSpace = async (urlWorkspace, defaultWorkSpace) => {
    console.log("login via url workspace", urlWorkspace);
    if (urlWorkspace) {
      let workSpace =
        this.props.loginDetails.userWorkSpaceList &&
        this.props.loginDetails.userWorkSpaceList.find(
          (data) => data.slug === urlWorkspace
        );
      console.log("login user workspace", workSpace);
      if (workSpace) {
        this.props.urlUpdateLoginDetails(workSpace);
        let workSpaceName = workSpace.slug ? workSpace.slug : "default";
        this.setState({
          urlPath: workSpaceName,
        });
        if (workSpaceName !== "default") {
          this.props.getWorkSpaceOptionTypes();
        }
        console.log("set-user-workspace-6", workSpaceName);

        sessionStorage.setItem("WORKSPACE", workSpaceName);
      } else {
        toast.warning("Your not authorized in this workspace ");
        if (defaultWorkSpace) {
          this.setState({
            urlPath: defaultWorkSpace,
          });
          console.log("set-user-workspace-7", defaultWorkSpace);

          sessionStorage.setItem("WORKSPACE", defaultWorkSpace);
          this.props.getAllNotSawAskHelpListCount(defaultWorkSpace);
        } else {
          console.log("set-user-workspace-8", "default");

          sessionStorage.setItem("WORKSPACE", "default");
          this.props.getAllNotSawAskHelpListCount("default");
        }
      }
    } else {
      console.log("set-user-workspace-9", "default");

      sessionStorage.setItem("WORKSPACE", "default");
      this.props.getAllNotSawAskHelpListCount("default");
    }
    this.setState({
      urlWorkspacePresent: false,
    });
  };
  render() {

    if (
      this.props.userDetails !== null &&
      this.props.authUser &&
      this.props.loginDetails

    ) {

      console.log("urlPath", this.props.defaultWorkSpace);
      return (
        <Redirect
          to={{

            pathname: `/${
              this.props.defaultWorkSpace
                ? this.props.defaultWorkSpace
                : "default"
            }/home`,
          }}
        />
      );
    } else if (
      !this.props.userDetails &&
      (this.props.loginUserError === "blocked_by_admin" ||
        this.props.loginUserError === "some_thing_wrong")
    ) {
      return (
        <>
          <ErrorUser></ErrorUser>
        </>
      );
    } else {
      return (
        <>
          <FullPageLoading></FullPageLoading>
        </>
      );
    }
  }
}

const mapStateToProps = function (state) {
  return {
    keycloakAuthenticated: state.loginDetailsApi.keycloakAuthenticated,
    userDetails: state.loginDetailsApi.userDetails,
    authUser: state.loginDetailsApi.authUser,
    workspaceType: state.loginDetailsApi.loginDetails?.userWorkSpace?.slug,
    homeImageStatus: state.commonApi.homeImageState,
    loginDetails: state.loginDetailsApi.loginDetails,
    defaultWorkSpace: state.loginDetailsApi.loginDetails?.defaultWorkSpace,
    loginUserError: state.loginDetailsApi.loginUserError,
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    urlUpdateLoginDetails: (name) => dispatch(urlUpdateLoginDetails(name)),
    keycloakLoginSuccess: (userDetails) =>
      dispatch(keycloakLoginSuccess(userDetails)),
    setUserDetails: (data, token) => dispatch(setUserDetails(data, token)),
    getFundingImageState: (status) => dispatch(getFundingImageState(status)),
    getUserWorkSpaceList: () => dispatch(getUserWorkSpaceList()),
    getWorkSpaceType: (type, role, id) =>
      dispatch(getWorkSpaceType(type, role, id)),
    getWorkSpaceOptionTypes: () => dispatch(getWorkSpaceOptionTypes()),
    getAllNotSawAskHelpListCount: () =>
      dispatch(getAllNotSawAskHelpListCount()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(KeyCloakLogin));
